import {Directive, Input, HostListener, ElementRef} from '@angular/core';

@Directive({
    selector: '[amdocs-image-fallback]'
})

export class AmdocsImageFallbackDirective {

    private fallback = false;

    @Input() defaultImageSrc: string;

    @HostListener('error')
    updateUrl(): void {
        if (!this.fallback) {
            this.fallback = true;
            this.el.nativeElement.src = this.defaultImageSrc;
        }
    }

    constructor(private el: ElementRef) {
    }
}
